import {
    add_msg,
} from '../actions'
export default {
    checkStatus: (response) => {
        if (response.status >= 200 && response.status < 300) {
            return response;
        }
        const error = new Error(response.statusText);
        error.response = response;
        throw error;
    },
    parseJSON: (response) => {
        return response.json();
    },
    postError: (error) => {
        if (!error.response){
            return add_msg('連線失敗', 'error')
        }
        if (error.response.status === 500){
            return add_msg('連線失敗', 'error')
        }
        error.response.json().then(function (data) {
            return add_msg(data.message, 'error')
        })
    }
}




// WEBPACK FOOTER //
// ./src/dashboards_redux/utils/fetchExtend.jsx